// echo.js
import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.Pusher = Pusher;

export function initEcho(token) {
  return new Echo({
    broadcaster: "pusher",
    key: "8970f144861cd9faada0",
    cluster: "ap2",
    forceTLS: true,
    encrypted: true,
    authEndpoint: "https://admin.from-malk.com/broadcasting/auth",
    auth: {
      headers: {
        Authorization: `Bearer ${token}`,
        Accept: "application/json",
      },
    },
  });
}
